import getEnvFromUrl from './get-env-from-url';

export default getEnvFromUrl;
